import React from 'react';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import get from 'lodash.get';
import ViewDocumentButton from './ViewDocumentButton/ViewDocumentButton';

const DocumentsTableBody = ({ documents = [], headerConfig, handleView }) => (
  <TableBody>
    {documents?.length === 0 && (
      <TableRow>
        <TableCell colSpan={7} style={{ textAlign: 'center' }}>
          Nincs adat
        </TableCell>
      </TableRow>
    )}
    {documents?.map(document => {
      return (
        <TableRow key={document?.guid}>
          {headerConfig.map(header => {
            if (header.ref === 'operations') {
              return (
                <TableCell key={header.ref} style={{ textAlign: 'center' }}>
                  <ViewDocumentButton
                    document={document}
                    handleView={handleView}
                  />
                </TableCell>
              );
            }

            let resolveDisplayName = get(document, header.ref);
            return (
              <TableCell key={header.ref}>
                {resolveDisplayName ? resolveDisplayName : '-'}
              </TableCell>
            );
          })}
        </TableRow>
      );
    })}
  </TableBody>
);

export default DocumentsTableBody;
